import { PqTimerExtras } from "@sabyr-dev/mist_core/lib/timer";
import { PqItemUsage } from "@sabyr-dev/mist_core/model/datasource/item";
import { GlobalState } from "@sabyr-dev/mist_core/model/datasource/state";
import { ItemModel } from "@sabyr-dev/mist_core/model/model/item";
import { ListModel } from "@sabyr-dev/mist_core/model/model/list";
import { MetadataModel } from "@sabyr-dev/mist_core/model/model/metadata";
import Model from "@sabyr-dev/mist_core/model/model/model";
import { ScoreModel } from "@sabyr-dev/mist_core/model/model/score";
import { SettingsModel } from "@sabyr-dev/mist_core/model/model/settings";
import { StateModel } from "@sabyr-dev/mist_core/model/model/state";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import {
	AcademyAttemptState, AcademyAttemptStateDataSource,
	AcademyAttemptTableRecord, AcademyGlobalStateDataSource,
	AcademyItemDataSource, AcademyListDataSource, AcademyMetadataDataSource,
	AcademyScoreDataSource, AcademySettingsDataSource
} from "./datasource";

export class AcademyModel extends Model<Product, Attempt, Quiz, Question, PqTimerExtras> {
	metadata: AcademyMetadataModel;
	// @ts-ignore
	item: AcademyItemModel;
	settings: AcademySettingsModel;
	score: AcademyScoreModel;
	state: {
		global: AcademyGlobalStateModel;
		attempt: AcademyAttemptStateModel;
	};
}

export abstract class AcademyListModel extends ListModel<Question> {
	datasource: AcademyListDataSource;
}

export abstract class AcademyItemModel extends ItemModel<Product, Attempt, Question, PqTimerExtras> {
	// @ts-ignore
	datasource: AcademyItemDataSource;

	abstract setPing(product: Product, attempt: Attempt, times: PqItemUsage<Question>[]): Promise<void>;
	// @ts-ignore
	abstract setFinished(product: Product, attempt: Attempt, total_time: number): Promise<string>;
}

export abstract class AcademyMetadataModel extends MetadataModel<Product, Attempt> {
	datasource: AcademyMetadataDataSource;

	abstract setIncomplete(product: Product, attempt: Attempt): Promise<string>;

	abstract getTestUrl(): Promise<string>;

	abstract revertToLocalCookie(): Promise<void>;
}

export abstract class AcademySettingsModel extends SettingsModel<Product> {
	datasource: AcademySettingsDataSource;

	abstract setEmail(product: Product, email: string): Promise<boolean>;
	abstract checkEmail(product: Product, email: string): Promise<boolean>;
}

export abstract class AcademyScoreModel extends ScoreModel<Attempt, Quiz> {
	datasource: AcademyScoreDataSource;

	abstract getAttempts(): Promise<AcademyAttemptTableRecord[]>;
	abstract restoreAttempts(): Promise<void>;
}

export abstract class AcademyGlobalStateModel extends StateModel<GlobalState> {
	datasource: AcademyGlobalStateDataSource;
}

export abstract class AcademyAttemptStateModel extends StateModel<AcademyAttemptState> {
	datasource: AcademyAttemptStateDataSource;
}

export default AcademyModel;
